import { useUpdateAtom } from "jotai/utils";
import { globalServiceEditorPropsAtom } from "@/components/Modals/service-editor-modal/atoms/globalModal";
import { tGlobalServiceEditorProps } from "@/components/Modals/service-editor-modal/types";
import { useCallback } from "react";
export const useMasterServiceEditor = () => {
  const setProps = useUpdateAtom(globalServiceEditorPropsAtom);
  return useCallback((props: Omit<tGlobalServiceEditorProps, "isOpen">) => {
    return setProps({
      isOpen: true,
      ...props,
    });
  }, []);
};
